import TextComponent from 'app_components/commons/TextComponent/TextComponent'
import React, { FC, ReactElement, useCallback, useState } from 'react'
import { Accordion, Card } from 'react-bootstrap'
import { BsArrowDownCircle, BsArrowUpCircle } from 'react-icons/bs'

import './AccordionTable.scss'

interface IAccordionTableProps {
  renderContent?: (item: any) => ReactElement
  renderHeader: (item: any) => ReactElement
  namesList?: string[]
  dataKeys?: string[]
  items: any[]
  id: string
}

const AccordionTable: FC<IAccordionTableProps> = ({
  items,
  renderContent,
  renderHeader,
  id,
  namesList,
  dataKeys,
}) => {
  const [activeKey, setActiveKey] = useState<string | undefined>(undefined)

  const handleOnSelect = (e: any) => {
    setActiveKey(e)
  }

  const renderIcon = useCallback((selectedKey: string) => {
    if (activeKey === selectedKey) {
      return (<BsArrowUpCircle size={16} />)
    }
    return (<BsArrowDownCircle size={16} />)
  }, [activeKey])

  return (
    <div className="accordion-table--layout">
      <Accordion activeKey={activeKey} onSelect={handleOnSelect}>
        {items?.map((item, idx) => (
          <Card className='accordion-table--card' key={`${id}-item-${idx}`}>
            <Accordion.Toggle className='accordion-table--toggle' eventKey={`${id}-item-${idx}`}>
              <div className="accordion-table--toggle-content">
                {renderHeader(item)}
              </div>
              <div className='accordion-table--toggle-icon'>
                {renderIcon(`${id}-item-${idx}`)}
              </div>
            </Accordion.Toggle>
            <Accordion.Collapse eventKey={`${id}-item-${idx}`}>
              <div className='accordion-table--collapse-content'>
                {renderContent ? renderContent(item) : (
                  <ul>
                    {namesList?.map((name, idx) => (
                      <li>
                        <TextComponent>
                          <strong>{name ? name : ''}: </strong>
                          {dataKeys ? item[dataKeys[idx]] : ''}
                        </TextComponent>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Accordion.Collapse>
          </Card>
        ))}
      </Accordion>
    </div>
  )
}

export default AccordionTable
